export const noTimeZoneFullISODate = 'YYYY-MM-DD[T]HH:mm:ss';
export const noTimeZoneLongISODate = 'YYYY-MM-DD HH:mm:ss';
export const noTimeZoneShortISODate = 'YYYY-MM-DD';
export const noTimeZoneTinyISODate = 'YYYY-MM';
export const transformDateFormat = 'DDMMYYYY';
export const dateFormatShow = 'DD MMM YYYY';
export const dateFormatShortMonth = 'DD-MM-YYYY';
export const dateFormatReservation = 'DD-MMM-YYYY';
export const dateFormatFullMonth = 'DD-MMMM-YYYY';
export const dateFormatPicker = 'dd MMM yyyy';
export const yearFormatPicker = 'yyyy';
export const monthShortDate = 'MMM D, YYYY';
export const monthAndYear = 'MMM YYYY';
export const shortDate = 'YYYY/MM/DD';
export const fullDate = 'YYYY/MM/DD HH:mm';
export const reverseShortDate = 'DD/MM/YYYY';
export const monthYearFormatPicker = 'MMM yyyy';
export const shortYearDate = 'DD/MM/YY';
export const fullHourFormat = 'HH:mm:ss';
export const hourFormat = 'HH:mm';
export const yearFormat = 'YYYY';
export const monthFormat = 'MM';
export const reverseDate = 'YYYYMMDD';
export const catalogDateFormat = 'D MMMM, YYYY HH:mm';
export const printDateFormat = 'DD-MMM HH:mm';
export const dashboardDateFormat = 'DD MMM HH:mm';
export const dateFormatLogin = 'DD-MM-YYYY H:mm';
export const originModificationDate = 'DD MMM YYYY - HH:mm';
export const orderDateFormat = 'DD/MM/YYYY HH:mm';
export const checkingDateFormat = 'DD-MMM HH:mm';
export const labelDateFormat = 'DD-MMM-YYYY HH:mm';
export const partAuditDateFormat = 'DD-MMM-YYYY hh:mm:ss';
export const fullDateShow = `${reverseShortDate} ${fullHourFormat}`;
